import { gravarPreferencia, lerPreferencia } from './preferenciaLocal';

/**
 * Se a sidebar abre recolhida. Chave inalterada (`randobr:sidebar-collapsed`) —
 * quem já tinha a preferência gravada continua com ela.
 */
const CHAVE = 'sidebar-collapsed';

export function getStoredSidebarCollapsed(): boolean {
  return lerPreferencia(CHAVE) === 'true';
}

export function setStoredSidebarCollapsed(collapsed: boolean): void {
  gravarPreferencia(CHAVE, String(collapsed));
}
